import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ToastrModule} from 'ngx-toastr';
import {NgxSpinnerModule} from 'ngx-spinner';
import {AppConfigService} from './services/appconfig.service';

import {TranslateModule} from '@ngx-translate/core';
import {LanguageModuleComponent} from './modules/language/language.component';
import {LanguageMobileModuleComponent} from './modules/language-mobile/language-mobile.component';

import {SearchModuleComponent} from './modules/search/search.component';
import {PublicHeaderComponent} from '../public-area/components/common/public/header/header.component';
import {PublicFooterComponent} from '../public-area/components/common/public/footer/footer.component';
import {PrivateFooterComponent} from '../public-area/components/common/private/footer/footer.component';
import {ServicesComponent} from '../personal-area/common/private/services/services.component';
import {ThematicAreasComponent} from '../personal-area/common/private/thematic-areas/thematic-areas.component';
import {ExtensionComponent} from '../personal-area/common/private/extension/extension.component';
import {SafeHtmlPipe} from "./pipes/safe-html.pipe";
import {
  CategoriesServiceClient
} from "./services/personal-area/institution-categories/institution-categories-client.service";
import {UrbanPaymentsService} from "./services/personal-area/urban-payments/urban-payments.service";
import {UrbanPaymentsClientService} from "./services/personal-area/urban-payments/urban-payments-client.service";
import {CartIconHeaderComponent} from "./modules/cart-icon-header/cart-icon-header.component";
import {NewCommonHeaderComponent} from "./common/new-common-header/new-common-header.component";
import {FnPipe} from "./pipes/fn.pipe";
import {TipoCarrelloPipe} from "./pipes/tipo-carrello.pipe";
import {CurrencyFormat100Pipe} from "./pipes/currency-format-100.pipe";
import {PaymentStatusPipe} from "./pipes/payment-status.pipe";
import {NumeroAvvisoDescriptionPipe} from "./pipes/numero-avviso-description.pipe";
import {GeneratedPositionModalComponent} from "./modals/generated-position-modal/generated-position-modal.component";
import {ConfirmPositionModalComponent} from "./modals/confirm-position-modal/confirm-position-modal.component";
import { ChangeTextDirective } from './directives/change-text.directive';
import { ResourceNotFoundComponent } from './common/resource-not-found/resource-not-found.component';
import { FooterAreaNotelegaliComponent } from './common/footer-area/notelegali/notelegali.component';
import { FooterAreaPrivacyComponent } from './common/footer-area/privacy/privacy.component';
import { PreHeadComponent } from './common/pre-head/pre-head.component';
import { MaterialModule } from './material.module';


@NgModule({ declarations: [
        PublicHeaderComponent,
        PublicFooterComponent,
        PrivateFooterComponent,
        NewCommonHeaderComponent,
        PreHeadComponent,
        ResourceNotFoundComponent,
        SearchModuleComponent,
        LanguageModuleComponent,
        LanguageMobileModuleComponent,
        CartIconHeaderComponent,
        ServicesComponent,
        ThematicAreasComponent,
        ExtensionComponent,
        SafeHtmlPipe,
        TipoCarrelloPipe,
        CurrencyFormat100Pipe,
        FnPipe,
        PaymentStatusPipe,
        NumeroAvvisoDescriptionPipe,
        GeneratedPositionModalComponent,
        ConfirmPositionModalComponent,
        // Directive
        ChangeTextDirective,
        // Privacy & Legal
        FooterAreaPrivacyComponent,
        FooterAreaNotelegaliComponent
    ],
    exports: [
        TranslateModule,
        PublicHeaderComponent,
        PublicFooterComponent,
        PrivateFooterComponent,
        NewCommonHeaderComponent,
        PreHeadComponent,
        ResourceNotFoundComponent,
        SearchModuleComponent,
        LanguageModuleComponent,
        LanguageMobileModuleComponent,
        ServicesComponent,
        ThematicAreasComponent,
        ExtensionComponent,
        SafeHtmlPipe,
        CartIconHeaderComponent,
        TipoCarrelloPipe,
        CurrencyFormat100Pipe,
        FnPipe,
        PaymentStatusPipe,
        NumeroAvvisoDescriptionPipe,
        GeneratedPositionModalComponent,
        ConfirmPositionModalComponent,
        // Directive
        ChangeTextDirective
    ], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        ToastrModule.forRoot(),
        NgxSpinnerModule,
        MaterialModule], providers: [
        AppConfigService,
        CategoriesServiceClient,
        UrbanPaymentsClientService,
        UrbanPaymentsService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class SharedModuleLibrary {
}
